import React, { useState, useEffect } from "react";
import "../Styles/HeightWeightModal.css";

function HeightWeightModal({
  visible,
  onClose,
  onDone,
  initialHeight = "5.6",
  initialWeight = "50",
}) {

  // ✅ Hooks MUST be first
  const [feet, setFeet] = useState(5);
  const [inch, setInch] = useState(6);
  const [weight, setWeight] = useState(60);

  useEffect(() => {
  if (visible) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return () => {
    document.body.style.overflow = "auto";
  };
}, [visible]);


  // ✅ Sync when modal opens
  useEffect(() => {
    if (visible) {
      setFeet(Number(initialHeight?.split(".")[0]) || 5);
      setInch(Number(initialHeight?.split(".")[1]) || 6);
      setWeight(Number(initialWeight) || 60);
    }
  }, [visible, initialHeight, initialWeight]);

  // ✅ Now safe
  if (!visible) return null;

  return (
    <div className="hw-backdrop">
      <div className="hw-box">

        <h4>Select Height & Weight</h4>

        <div className="hw-columns">

          {/* Feet */}
          <div>
            {[4, 5, 6, 7,8,9,10].map((f) => (
              <div
                key={f}
                className={`hw-item ${feet === f ? "active" : ""}`}
                onClick={() => setFeet(f)}
              >
                {f} ft
              </div>
            ))}
          </div>

          {/* Inch */}
          <div>
            {[...Array(12).keys()].map((i) => (
              <div
                key={i}
                className={`hw-item ${inch === i ? "active" : ""}`}
                onClick={() => setInch(i)}
              >
                {i} in
              </div>
            ))}
          </div>

          {/* Weight */}
          <div>
            {[...Array(150).keys()].slice(35).map((w) => (
              <div
                key={w}
                className={`hw-item ${weight === w ? "active" : ""}`}
                onClick={() => setWeight(w)}
              >
                {w} kg
              </div>
            ))}
          </div>

        </div>

        <button
          className="hw-done"
          onClick={() => {
            onDone(`${feet}.${inch}`, String(weight));
            onClose();
          }}
        >
          Done
        </button>

      </div>
    </div>
  );
}

export default HeightWeightModal;
